import type { TOC } from '@ember/component/template-only';

const BoardsRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default BoardsRouteTemplate;
